<template>
  <div>
    <div class="_contacts-wrapper" :class="{ 'no-background': success }">
      <div class="_contacts">
        <div class="_contacts-left" :class="{ '_success': success }">
          <h1>Финсайт всегда <br><span>на связи</span></h1>
          <address v-html="content" />
        </div>
        <div class="_contacts-right">
          <div v-if="false && success" class="success">Ваше обращение принятно, мы&nbsp;свяжемся
            с&nbsp;вами&nbsp;в&nbsp;ближайшее время
          </div>
          <div v-if="success" class="_profile-change-password-success">
            <img class="_profile-change-password-success-image" src="@/assets/images/password-change-success.svg"
              alt="Финсайт">
            <div class="_profile-change-password-success-title">Ваше обращение принято, мы <br>свяжемся с вами в ближайшее
              время</div>
          </div>
          <!--          <div class="error" v-if="error.name || error.phone || error.email || error.message || error.agreement">-->
          <!--            <template v-if="error.name">Укажите имя<br></template>-->
          <!--            <template v-if="error.phone">Укажите телефон<br></template>-->
          <!--            <template v-if="error.email">Укажите e-mail<br></template>-->
          <!--            <template v-if="error.message">Укажите сообщение<br></template>-->
          <!--            <template v-if="error.agreement">Примите пользовательское соглашение</template>-->
          <!--          </div>-->
          <form v-else>
            <div class="input-group">
              <label for="name">
                <span v-if="error.name" class="input-label-error">Укажите имя</span>
                <template v-else>Ваше имя</template>
              </label>
              <input type="text" id="name" v-model="name" key="name" class="text-input text-input-name"
                :class="{ 'text-input-error': error.name }">
            </div>
            <div class="input-group">
              <label for="phone">
                <span v-if="error.phone" class="input-label-error">{{ error.phone }}</span>
                <template v-else>Ваш телефон</template>
              </label>
              <input type="tel" v-model="phone" v-mask="'+7 ### ### ## ##'" id="phone" class="text-input text-input-phone"
                :class="{ 'text-input-error': error.phone }" />
            </div>
            <div class="input-group">
              <label for="email">
                <span v-if="error.email" class="input-label-error">{{ error.email }}</span>
                <template v-else>Ваш e-mail</template>
              </label>
              <input type="text" v-model="email" id="email" class="text-input"
                :class="{ 'text-input-error': error.email }" />
            </div>
            <div class="input-group" style="margin-bottom: 20px;">
              <label for="message">
                <span v-if="error.message" class="input-label-error">Напишите ваше обращение</span>
                <template v-else>Ваше сообщение</template>
              </label>
              <textarea v-model="message" id="message" class="text-input"
                :class="{ 'text-input-error': error.message }" />
            </div>
            <div class="input-group button-group" style="margin-bottom: 20px;">
              <input type="submit" value="Отправить" class="button blue" @click.prevent="handleSubmit">
            </div>
            <div class="agreement-container">
              <input type="checkbox" id="agreement" v-model="agreement">
              <label for="agreement" class="agreement" :class="{ 'checkbox-error': error.agreement }">
                Нажимая на кнопку “Отправить” Вы принимаете <a href="/privacy" target="_blank">Условия
                  использования сервиса
                  “Финсайт”</a>, даете
                <a href="/privacy" target="_blank">согласие на обработку своих персональных
                  данных и соглашаетесь с условиями политики конфиденциальности</a>
              </label>
            </div>
          </form>
        </div>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>

import request from "@/api/axios";

export default {
  name: 'Contacts',
  data: () => ({
    name: '',
    phone: '',
    email: '',
    message: '',
    // name: 'Виталий Пономаренко',
    // phone: '+7 965 407 00 39',
    // email: 'vitaliy.ponomarenko@gmail.com',
    // message: 'Учитывая ключевые сценарии поведения, современная методология разработки, в своём классическом представлении, допускает внедрение распределения внутренних резервов и ресурсов.',
    error: {},
    agreement: true,
    success: false
  }),
  computed: {
    content() {
      return window._content?.PROPERTY_FEEDBACK_TEXT_VALUE;
    }
  },
  methods: {
    removeErrors() {
      this.error = {
        name: false,
        email: false,
        message: false,
        phone: false,
        agreement: false
      }
    },
    handleSubmit() {
      this.removeErrors();
      this.success = false;
      if (!this.name.length) {
        this.error.name = true;
      }
      if (!this.phone.length) {
        this.error.phone = 'Укажите телефон';
      } else if (this.phone.length !== 16) {
        this.error.phone = 'Укажите корректный номер телефона';
      }
      if (!this.email.length) {
        this.error.email = 'Укажите e-mail';
      } else if (!this.validateEmail(this.email)) {
        this.error.email = 'Укажите корректный e-mail';
      }
      if (!this.message.length) {
        this.error.message = true;
      }
      if (!this.agreement) {
        this.error.agreement = true;
      }
      if (this.error.name || this.error.email || this.error.message || this.error.agreement) return false;

      request({
        action: 'feedback',
        options: {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
        }
      });

      this.success = true;
      this.name = '';
      this.email = '';
      this.phone = '';
      this.message = '';
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
</script>

<style scoped lang="scss">
._contacts-wrapper {
  background-image: url('~@/assets/images/contacts-bg.png');
  background-repeat: no-repeat;
  background-position: right -148px top;
  //background-size: contain;
  background-size: 475px auto;

  @media screen and (max-width: 1420px) {
    background-position: right -254px top;
    //background-size: contain;
  }

  //@media screen and (max-width: 1200px) {
  //  background: none;
  //}

  @media screen and (max-width: 650px) {
    background-size: 267px auto;
    background-position: right -146px top;
  }

  &.no-background {
    background-image: none !important;
  }
}

hr {
  @media screen and (max-width: 650px) {
    display: none;
  }
}

._contacts {
  max-width: 1024px;
  margin: 73px auto 0;
  padding-top: 40px;
  display: flex;
  padding-bottom: 30px;

  .error {
    margin-bottom: 30px;
    font-size: 15px;
    color: red;
  }

  @media screen and (max-width: 650px) {
    flex-direction: column;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 93px;
  }

  .input-group {
    margin-bottom: 32px;

    input[type="submit"] {
      cursor: pointer;
      display: block;
      width: 100%;
      outline: none;
      background: #0f01e5;
      border-radius: 8px;
      color: #fff;
      padding: 16px;
      text-align: center;
      font-size: 16px;
      line-height: 16px;
      border: none;
      max-width: 250px;
      font-weight: 600;

      @media screen and (max-width: 650px) {
        max-width: 100%;
      }
    }

    .text-input {
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #e2e2e2;
      padding: 8px 0;
      background-color: transparent;
      width: 100%;
      outline: none;
      margin-bottom: 0;
      font-family: Gilroy;
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      color: #414141;

      @media screen and (max-width: 650px) {

        &[id="name"],
        &[id="phone"] {
          margin-right: 100px;
        }
      }

      &.text-input-error {
        border-color: red;
      }
    }

    textarea {
      height: 128px;
      resize: none;
      padding: 8px 0;
      font-size: 18px;
      line-height: 22px;

      @media screen and (max-width: 650px) {
        height: 178px;
      }
    }

    .text-input-name {
      color: #0500e5;
    }

    .text-input-phone {
      color: #0500e5;
    }

    label {
      margin-bottom: 0;
      font-family: Circe;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 140%;
      color: #828282;
    }
  }

  ._contacts-left {

    @media screen and (max-width: 650px) {
      &._success {
        display: none !important;
      }
    }

    address {
      margin-top: 32px;
      font-family: Circe;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 180%;
      color: #828282;

      @media screen and (max-width: 650px) {
        display: none;
      }

      ::v-deep {

        a {
          color: #828282;
          font-weight: normal;
        }
      }
    }

    h1 {
      line-height: 50px;

      @media screen and (max-width: 650px) {
        margin-bottom: 44px;
        font-size: 24px;
        line-height: 27px;
      }
    }

    h1 span {
      font-family: 'EB Garamond';
      font-style: italic;
      font-weight: bold;
      font-size: 48px;
      color: #0500e5;

      @media screen and (max-width: 650px) {
        font-size: 24px;
        line-height: 27px;
      }
    }
  }

  ._contacts-right {
    margin-left: 120px;
    flex-grow: 1;
    max-width: 400px;

    @media screen and (max-width: 650px) {
      margin-left: 0;
      max-width: 100%;
    }
  }

  .agreement-container {
    display: flex;
    position: relative;
  }

  .agreement {
    font-family: Circe;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 140%;
    margin-left: 10px;
    color: #828282;

    a {
      color: #2F80ED;
      font-weight: normal;
    }
  }

  .agreement-container input[type="checkbox"] {
    display: none;
  }

  .agreement-container label {
    position: relative;
    padding-left: 30px;
    margin-left: 0;
    cursor: pointer;
    text-align: left;
  }

  .agreement-container label:before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border: 2px solid #c4c4c4;
    position: absolute;
    top: 2px;
    left: 0;
    cursor: pointer;
    border-radius: 2px;
  }

  .agreement-container label:after {
    content: '';
    display: none;
    width: 12px;
    height: 12px;
    background: #0f01e5;
    top: 6px;
    left: 4px;
    position: absolute;
  }

  .agreement-container input[type="checkbox"]:checked+label:after {
    display: block;
  }

  .input-label-error {
    color: #eb5757;
  }

  .agreement-container label.checkbox-error:before {
    border-color: red;
  }
}

._profile-change-password-success {
  text-align: center;

  ._profile-change-password-success-image {
    margin-bottom: 27px;
  }

  ._profile-change-password-success-title {
    font-family: Gilroy;
    font-size: 32px;
    line-height: 37px;
    color: #333;
    margin-bottom: 27px;
    font-weight: bold;
  }
}
</style>
